document.addEventListener('DOMContentLoaded', function () {
  console.log('DOM fully loaded and parsed');

  const buttons = document.querySelectorAll('.free-gift-button');
  console.log('Buttons found:', buttons);

  buttons.forEach(button => {
      console.log('Attaching click event to button:', button);
      button.addEventListener('click', function (event) {
          event.preventDefault();  // Prevent default action if any
          console.log('Delegated click event on button:', this);

          const gwpTitle = this.getAttribute('data-gwp-title');
          const gwpDescription = this.getAttribute('data-gwp-description');
          const gwpImage = this.getAttribute('data-gwp-image');
          const gwpDisclaimer = this.getAttribute('data-gwp-disclaimer');

          console.log('GWP Title:', gwpTitle);
          console.log('GWP Description:', gwpDescription);
          console.log('GWP Image:', gwpImage);
          console.log('GWP Disclaimer:', gwpDisclaimer);

          const swalOptions = {
              title: gwpTitle || 'GWP Title',
              text: gwpDescription || 'GWP Description',
              imageWidth: 400,
              imageAlt: gwpTitle || 'GWP Image',
              footer: gwpDisclaimer || 'GWP Disclaimer'
          };

          if (gwpImage) {
              console.log('GWP Image URL:', gwpImage);
              if (gwpImage.includes('no-image')) {
                  swalOptions.imageHeight = 0;
              } else {
                  swalOptions.imageUrl = gwpImage;
              }
          }

          Swal.fire(swalOptions);
      });
  });

  // Fallback event delegation
  document.body.addEventListener('click', function (event) {
      if (event.target && event.target.classList.contains('free-gift-button')) {
          event.preventDefault();
          console.log('Delegated click event on button:', event.target);

          const gwpTitle = event.target.getAttribute('data-gwp-title');
          const gwpDescription = event.target.getAttribute('data-gwp-description');
          const gwpImage = event.target.getAttribute('data-gwp-image');
          const gwpDisclaimer = event.target.getAttribute('data-gwp-disclaimer');

          console.log('GWP Title:', gwpTitle);
          console.log('GWP Description:', gwpDescription);
          console.log('GWP Image:', gwpImage);
          console.log('GWP Disclaimer:', gwpDisclaimer);

          const swalOptions = {
              title: gwpTitle || 'GWP Title',
              text: gwpDescription || 'GWP Description',
              imageWidth: 400,
              imageAlt: gwpTitle || 'GWP Image',
              footer: gwpDisclaimer || 'GWP Disclaimer'
          };

          if (gwpImage) {
              console.log('GWP Image URL:', gwpImage);
              if (gwpImage.includes('no-image')) {
                  swalOptions.imageHeight = 0;
              } else {
                  swalOptions.imageUrl = gwpImage;
              }
          }

          Swal.fire(swalOptions);
      }
  });
});